/* ===========================================
   Feat Collection Variants – v1.0.3-safeRUK
   =========================================== */
(() => {
  const VERSION = '1.0.3-safeRUK';
  const MAX_TRIES = 30;
  const RETRY_INTERVAL = 1000;

  const debug = {
    shown: !!localStorage.getItem('featcvDebug'),
    log: (icon, ...a) => {
      console.log('[FeatCV]', ...a);
      const el = document.getElementById('featcv-log');
      if (el) el.textContent += `${new Date().toISOString().slice(11, 19)} ${icon} ${a.join(' ')}\n`;
    },
  };
  const log  = (...a) => debug.log('ℹ️', ...a);
  const warn = (...a) => debug.log('⚠️', ...a);
  const err  = (...a) => debug.log('❌', ...a);

  function ensurePanel() {
    if (document.getElementById('featcv-debug')) return;
    const box = document.createElement('div');
    box.id = 'featcv-debug';
    box.style.cssText = `
      position:fixed;bottom:8px;right:8px;z-index:2147483000;
      background:#111827;color:#E2E8F0;font:12px monospace;
      width:360px;max-height:45vh;border:1px solid #334155;border-radius:8px;
      display:${debug.shown ? 'block' : 'none'};
    `;
    box.innerHTML = `
      <div style="background:#1E293B;padding:4px 8px;display:flex;justify-content:space-between;">
        <b>FeatCV Debug v${VERSION}</b>
        <button id="featcv-hide" style="background:none;color:#E2E8F0;border:none;cursor:pointer;">F9</button>
      </div>
      <pre id="featcv-log" style="margin:0;padding:6px;white-space:pre-wrap;overflow:auto;max-height:38vh;"></pre>
    `;
    document.body.appendChild(box);
    box.querySelector('#featcv-hide').onclick = () => togglePanel();
  }

  function togglePanel() {
    debug.shown = !debug.shown;
    const el = document.getElementById('featcv-debug');
    if (el) el.style.display = debug.shown ? 'block' : 'none';
    if (debug.shown) localStorage.setItem('featcvDebug', '1');
    else localStorage.removeItem('featcvDebug');
  }

  window.addEventListener('keydown', e => e.key === 'F9' && togglePanel());
  ensurePanel();

  log('🚀 feat-cv.js loaded', VERSION);

  function safeLoadRUK() {
    if (typeof window.RUK === 'function') {
      log('✅ Reviews.io already available');
      return;
    }

    const existing = document.querySelector('script[src*="rating-snippet"]');
    if (existing) {
      log('📦 Found Reviews.io script but RUK not initialized yet');
      return;
    }

    const s = document.createElement('script');
    s.src = 'https://widget.reviews.io/rating-snippet/dist.js';
    s.async = true;
    s.onload = () => log('✅ Reviews.io script loaded safely');
    s.onerror = e => err('❌ Failed to load Reviews.io script', e);
    document.body.appendChild(s);
    log('📤 Injected safe Reviews.io script');
  }

  function renderRUKSnippets(tries = 0) {
    if (typeof window.RUK === 'function') {
      try {
        log(`⭐ RUK ready (after ${tries} tries), rendering...`);
        window.RUK('render', '.ruk_rating_snippet2');
      } catch (e) {
        err('RUK render failed:', e);
      }
    } else if (tries < MAX_TRIES) {
      warn(`⏳ RUK not ready (try ${tries})`);
      if (tries === 5) safeLoadRUK();
      setTimeout(() => renderRUKSnippets(tries + 1), RETRY_INTERVAL);
    } else {
      err(`💀 Gave up waiting for RUK after ${MAX_TRIES} tries`);
    }
  }

  function roundDiscount(value) {
    return Math.round(value);
  }

  function formatMoneyNoLocale(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return '0,00';

    if (num >= 1000) {
      return (num / 100).toFixed(2).replace('.', ',');
    }

    return num.toFixed(2).replace('.', ',');
  }

  function variantMoneyValueToCents(val) {
    const n = parseFloat(val);
    if (!Number.isFinite(n) || n < 0) return '';
    if (n >= 1000 && Number.isInteger(n)) return String(Math.round(n));
    return String(Math.round(n * 100));
  }

  function keepScrollPosition(scrollY) {
    const target = Number(scrollY) || 0;
    if (target <= 0) return;

    window.scrollTo(0, target);
    setTimeout(() => window.scrollTo(0, target), 50);
    setTimeout(() => window.scrollTo(0, target), 150);
    setTimeout(() => window.scrollTo(0, target), 350);
    setTimeout(() => window.scrollTo(0, target), 700);
  }

  function cvPriceHTML(p, btn) {
    const v = p.variants.find(x => x.available) || p.variants[0];

    const priceStr = formatMoneyNoLocale(v.price);
    const compareStr = v.compare_at_price ? formatMoneyNoLocale(v.compare_at_price) : null;

    const hasDiscount = v.compare_at_price && v.compare_at_price > v.price;
    const hasMultipleVariants = Array.isArray(p.variants) && p.variants.length > 1;
    const prefix = hasMultipleVariants ? 'ab ' : '';

    let discountBadge = '';
    if (hasDiscount) {
      const diff = v.compare_at_price - v.price;
      const pct = roundDiscount((diff * 100) / v.compare_at_price);
      discountBadge = ` <span class="discount-badge">-${pct}%</span>`;
    }

    const rawP = parseFloat(v.price);
    const priceCentsNum =
      Number.isFinite(rawP) && rawP >= 1000 && Number.isInteger(rawP)
        ? Math.round(rawP)
        : Number.isFinite(rawP)
          ? Math.round(rawP * 100)
          : 0;

    let optionInner;
    if (window.Shopify && typeof window.Shopify.scFormatMoney === 'function' && priceCentsNum > 0) {
      optionInner = window.Shopify.scFormatMoney(priceCentsNum);
      if (hasMultipleVariants) optionInner = `${prefix}${optionInner}`;
    } else {
      optionInner = `${prefix}${priceStr}€`;
    }
    const optionSpan = `<span class="option-price">${optionInner}</span>`;

    const base = hasDiscount
      ? `<s>${compareStr}€</s> <strong class="discounted-price">${optionSpan}</strong>${discountBadge}`
      : `<strong>${optionSpan}</strong>`;

    const hasDeposit = btn?.dataset?.hasDeposit === 'true';
    const unitPrice = btn?.dataset?.unitPrice || '';
    const unitReferenceValue = btn?.dataset?.unitReferenceValue || '';
    const unitReferenceUnit = btn?.dataset?.unitReferenceUnit || '';

    const cleanUnitPrice = unitPrice.replace(',', '.');

    let subLine = `
      <p class="bundle-subprice">
        inkl. MwSt. zzgl. <a href="/pages/versand" class="bundle-shipping-link">Versand</a>
        ${hasDeposit ? ` <span class="deposit_de">&amp; Pfand</span>` : ''}
        ${cleanUnitPrice && cleanUnitPrice !== '0.00'
          ? ` <span class="bundle-subprice-separator">|</span> ${cleanUnitPrice}€ / ${unitReferenceValue || 1}${unitReferenceUnit}`
          : ''}
      </p>
    `;

    return {
      html: base + subLine,
      id: v.id,
      sku: v.sku,
      url: p.url,
      hasMultipleVariants,
    };
  }

  function getModalEls() {
    return {
      inject: document.querySelector('.quick-add__popUpModalInject'),
      parent: document.querySelector('.quick-add__popUpModal'),
      closeBtn: document.querySelector('.quick-add__popUpModal__close'),
      bodyOverlay: document.querySelector('.body-overlay'),
    };
  }

  function closeFeatCvModal() {
    const { inject, parent } = getModalEls();
    document.body.classList.remove('overlay');
    document.body.classList.remove('overflow-hidden');
    if (parent) parent.classList.remove('active');
    if (inject) setTimeout(() => { inject.innerHTML = ''; }, 500);
  }

  (function bindModalCloseOnce() {
    if (window.__featcvModalCloseBound) return;
    window.__featcvModalCloseBound = true;

    const { closeBtn, bodyOverlay } = getModalEls();
    if (closeBtn) closeBtn.addEventListener('click', closeFeatCvModal);
    if (bodyOverlay) bodyOverlay.addEventListener('click', closeFeatCvModal);
  })();

  function popupModalOptionTemplate(optionList, variantList, product, collectionIds, triggerBtn) {
    const money = (value) => {
      const num = parseFloat(value);

      if (isNaN(num)) return '0.00€';

      if (window.Shopify && typeof window.Shopify.scFormatMoney === 'function') {
        const cents = num >= 1000 ? num : num * 100;
        return window.Shopify.scFormatMoney(cents);
      }

      return `${formatMoneyNoLocale(num)}€`;
    };

    const imageSrc = product?.image?.src || product?.images?.[0]?.src || '';
    const title = product?.title || '';
    const coll = collectionIds != null ? String(collectionIds) : '';
    const pid = product?.id != null ? String(product.id) : '';

    const giftCardJson = document.querySelector('[gift-card-json-data]');
    let giftCardArr = [];
    try {
      giftCardArr = giftCardJson ? JSON.parse(giftCardJson.innerHTML).realGiftCardProduct : [];
    } catch (e) {
      giftCardArr = [];
    }
    if (!Array.isArray(giftCardArr)) giftCardArr = [];

    let generatedValueList = '';
    (variantList || []).forEach((variant) => {
      let discount = null;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        let variant_savings = ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price;
        variant_savings =
          typeof window.roundDiscount === 'function'
            ? window.roundDiscount(variant_savings)
            : roundDiscount(variant_savings);
        if (variant_savings > 0) discount = 'Du sparst ' + variant_savings + '%';
      }

      let variantTitle = variant.option1 || '';
      if (variant.option2) variantTitle += ' / ' + variant.option2;
      if (variant.option3) variantTitle += ' / ' + variant.option3;

      let variantID = variant.id;
      if (triggerBtn && triggerBtn.hasAttribute('gift-card-product')) {
        if (
          triggerBtn.hasAttribute('option-name-to-replace') &&
          variantTitle.includes(triggerBtn.getAttribute('option-name-to-replace'))
        ) {
          for (let i = 0; i < giftCardArr.length; i++) {
            const giftCardValue = variantTitle.split(' / ')[1];
            if (giftCardValue == giftCardArr[i].name) {
              variantID = giftCardArr[i].id;
              break;
            }
          }
        }
      }

      const cap = variant.compare_at_price != null && variant.compare_at_price !== '' ? variant.compare_at_price : '';

      const hasCompareSale =
        variant.compare_at_price != null &&
        variant.compare_at_price !== '' &&
        Number(variant.compare_at_price) > Number(variant.price);

      const compareMoney = hasCompareSale
        ? window.Shopify && typeof window.Shopify.scFormatMoney === 'function'
          ? window.Shopify.scFormatMoney(parseFloat(variant.compare_at_price, 10) * 100)
          : money(variant.compare_at_price)
        : '';

      const priceMoney =
        window.Shopify && typeof window.Shopify.scFormatMoney === 'function'
          ? window.Shopify.scFormatMoney(parseFloat(variant.price, 10) * 100)
          : money(variant.price);
      const unitRef = variant.unit_price_measurement?.reference_value;
      const unitQty = variant.unit_price_measurement?.quantity_unit || '';

      generatedValueList += `
                  <button
                    data-variant-id="${variantID}"
                    data-product-id="${pid}"
                    data-option-title="${variantTitle}"
                    data-collections="${coll.replace(/"/g, '&quot;')}"
                    data-original-price="${variant.price}"
                    data-compare-at-price="${cap}"
                    ${discount ? `savings="${discount}"` : ''}
                  >
                    <span class="option-title">${variantTitle} -</span>
                    ${hasCompareSale ? `<span class="option-compare-at-price">${compareMoney}</span>` : ''}
                    <span class="option-price">${priceMoney}</span>
                    ${variant.unit_price > 0 ? `<div class="option-unit-price">
                        ${money(variant.unit_price)} / ${unitRef != null ? unitRef : 1}${unitQty}
                      </div>` : ''}
                  </button>
                `;
    });

    return `
      <div class="quick-add__popUpModal__optionList" data-option-count="1">
        <div class="quick-add__popUpModal__option" data-option="1">
          <div class="quick-add__popUpModal__imageTitleWrapper">
            <span class="quick-add__popUpModal__productImage">
              <img src="${imageSrc}" loading="lazy" width="64" height="64" alt="" />
            </span>
            <span class="quick-add__popUpModal__productTitle">${title}</span>
          </div>
          <div class="quick-add__popUpModal__optionWrapper">
            ${generatedValueList}
          </div>
        </div>
      </div>
    `;
  }

  function addMatchedItemToCart(variantId, depositVariantId, depositAmount) {
    const currentScrollY = window.__featcvLastScrollY || window.scrollY || window.pageYOffset || 0;
    const openCartButton = document.querySelector('#cart-icon-bubble[role="button"]') || document.querySelector('#cart-icon-bubble');
    let cartItems;

    if (depositAmount && depositVariantId) {
      cartItems = { items: [ { id: depositVariantId, quantity: depositAmount }, { id: variantId, quantity: 1 } ] };
    } else {
      cartItems = { id: variantId, quantity: 1 };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartItems),
    })
      .then((response) => response.json())
      .then((response) => {
        fetch(window.location.href)
          .then((r) => r.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            const oldDrawer = document.querySelector("cart-drawer");
            const newDrawer = html.querySelector("cart-drawer");
            const oldIconCart = document.querySelector("#cart-icon-bubble");
            const newIconCart = html.querySelector("#cart-icon-bubble");

            if (oldIconCart && newIconCart) oldIconCart.innerHTML = newIconCart.innerHTML;
            if (oldDrawer && newDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;

            if (response.item_count == 0) {
              const cd = document.querySelector("cart-drawer");
              if (cd) cd.classList.add("is-empty");
            } else {
              const cd = document.querySelector("cart-drawer");
              if (cd) cd.classList.remove("is-empty");
            }

            setTimeout(() => { document.dispatchEvent(new CustomEvent("rerenderCart")); }, 100);
          })
          .catch((e) => { console.error(e); });
      });

    if (openCartButton) {
      setTimeout(() => {
        openCartButton.click();
        keepScrollPosition(currentScrollY);
      }, 250);
    }
  }

  function openFeatCvModalForHandle(handle, collectionIds, triggerBtn) {
    const { inject, parent } = getModalEls();
    if (!inject || !parent) {
      err('❌ Modal elements not found (.quick-add__popUpModalInject / .quick-add__popUpModal)');
      return;
    }

    const savedScrollY = window.__featcvLastScrollY || window.scrollY || window.pageYOffset || 0;

    inject.innerHTML = '';

    document.body.classList.add('overlay');
    parent.classList.add('active');

    keepScrollPosition(savedScrollY);

    const productFetchUrl = `/products/${handle}.json`;
    log('🧩 FeatCV modal fetch', productFetchUrl);

    fetch(productFetchUrl)
      .then((res) => res.json())
      .then((res) => {
        const product = res.product || res;
        const coll = collectionIds != null ? String(collectionIds) : '';

        inject.innerHTML = popupModalOptionTemplate(
          product.options,
          product.variants,
          product,
          coll,
          triggerBtn || null
        );
        inject.setAttribute('data-product-id', String(product.id));
        if (coll) inject.setAttribute('data-collections', coll);
        else inject.removeAttribute('data-collections');

        document.dispatchEvent(new CustomEvent("discount-apply", { detail: {} }));

        const optionButtons = inject.querySelectorAll(".quick-add__popUpModal__optionList button");
        optionButtons.forEach((btn) => {
          btn.addEventListener("click", () => {
            const currentScrollY = window.__featcvLastScrollY || window.scrollY || window.pageYOffset || 0;
            const prevActive = inject.querySelector("button.selected");
            if (prevActive) prevActive.classList.remove("selected");
            btn.classList.add("selected");

            const variantId = btn.dataset.variantId;
            if (!variantId) return;

            const depositArr = window.depositProductInfos || [];
            const targetDepositProduct = Array.isArray(depositArr)
              ? depositArr.find((p) => p.productId === product.id)
              : null;

            if (targetDepositProduct) {
              const depositInfo = (targetDepositProduct.variants || []).find((dep) => dep.variantId == variantId);
              if (depositInfo) {
                addMatchedItemToCart(variantId, depositInfo.depositId, depositInfo.depositAmount);
              } else {
                addMatchedItemToCart(variantId);
              }
            } else {
              addMatchedItemToCart(variantId);
            }

            closeFeatCvModal();
            keepScrollPosition(currentScrollY);
          });
        });
      })
      .catch((e) => {
        console.error(e);
        err('❌ FeatCV modal fetch failed', e);
        closeFeatCvModal();
      });
  }

  function bindChooseBtn(chooseBtn) {
    if (!chooseBtn) return;
    if (chooseBtn.dataset.featcvChooseBound === '1') return;
    chooseBtn.dataset.featcvChooseBound = '1';

    const saveScrollBeforeOpen = () => {
      window.__featcvLastScrollY = window.scrollY || window.pageYOffset || 0;
    };

    chooseBtn.addEventListener('pointerdown', saveScrollBeforeOpen, true);
    chooseBtn.addEventListener('mousedown', saveScrollBeforeOpen, true);
    chooseBtn.addEventListener('touchstart', saveScrollBeforeOpen, true);

    chooseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      window.__featcvLastScrollY = window.__featcvLastScrollY || window.scrollY || window.pageYOffset || 0;

      const handle = chooseBtn.dataset.handle;
      if (!handle) {
        warn('⚠️ No handle set on choose button yet');
        return;
      }

      chooseBtn.classList.add('loading');
      const sp = chooseBtn.querySelector('.loading-overlay__spinner');
      if (sp) sp.classList.remove('hidden');

      try {
        openFeatCvModalForHandle(handle, chooseBtn.dataset.collections || '', chooseBtn);
      } finally {
        setTimeout(() => {
          chooseBtn.classList.remove('loading');
          if (sp) sp.classList.add('hidden');
        }, 150);
      }
    }, true);
  }

  async function initFeatCV(root, isMobile = false) {
    if (!root) return;
    log('🧩 Init FeatCV', { isMobile });

    const titleEl   = root.querySelector("[data-role='title']");
    const priceEl   = root.querySelector("[data-role='price']");
    const ratingEl  = root.querySelector("[data-role='rating']");
    const variantId = root.querySelector("[data-role='variant-id']");
    const depositVariantId = root.querySelector("[data-role='deposit-variant-id']");
    const depositVariantAmount = root.querySelector("[data-role='deposit-variant-amount']");
    const atcBtn    = root.querySelector("[data-role='atc']");
    let   chooseBtn = root.querySelector("[data-role='choose']");
    const buttons   = root.querySelectorAll('.feat-cv__variant-btn');

    bindChooseBtn(chooseBtn);

    const cache = {};
    async function getProduct(handle) {
      if (cache[handle]) return cache[handle];
      const r = await fetch(`/products/${handle}.js`);
      const d = await r.json();
      cache[handle] = d;
      return d;
    }

    async function activate(btn) {
      buttons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const handle = btn.dataset.handle;
      const sku    = btn.dataset.sku;
      const direct = btn.dataset.direct === 'true';
      const selectedDepositId = btn.dataset.depositId || '';
      const selectedDepositAmount = btn.dataset.depositAmount || '';

      log('🛒 Variant clicked', { handle, sku, direct });

      const p  = await getProduct(handle);
      const pr = cvPriceHTML(p, btn);

      if (titleEl) titleEl.textContent = p.title;
      if (priceEl) priceEl.innerHTML  = pr.html;

      if (priceEl && priceEl.getAttribute('data-role') === 'price') {
        const vSel =
          (p.variants || []).find((x) => String(x.id) === String(pr.id)) ||
          (p.variants || []).find((x) => x.available) ||
          ((p.variants || [])[0]);
        if (vSel) {
          priceEl.setAttribute('data-product-id', String(p.id));
          const opC = variantMoneyValueToCents(vSel.price);
          if (opC) priceEl.setAttribute('data-original-price', opC);
          const cmp =
            vSel.compare_at_price != null && vSel.compare_at_price !== ''
              ? variantMoneyValueToCents(vSel.compare_at_price)
              : '';
          if (cmp) priceEl.setAttribute('data-compare-at-price', cmp);
          else priceEl.removeAttribute('data-compare-at-price');
          const meta = btn.querySelector('.feat-cv__variant-price');
          const coll = meta?.dataset?.collections || btn.dataset?.collections || '';
          if (coll) priceEl.setAttribute('data-collections', coll);
          else priceEl.removeAttribute('data-collections');
        }
        document.dispatchEvent(new CustomEvent('discount-apply', { detail: {} }));
      }

      if (variantId) variantId.value  = pr.id;
      if (depositVariantId) depositVariantId.value = selectedDepositAmount ? selectedDepositId : '';
      if (depositVariantAmount) depositVariantAmount.value = selectedDepositAmount;
      if (ratingEl)  ratingEl.dataset.sku = pr.sku || sku || '';

      if (chooseBtn) {
        chooseBtn.dataset.handle = handle;
        const quickUrl = `/products/${handle}?view=quick-add`;
        chooseBtn.dataset.productUrl = quickUrl;
        chooseBtn.dataset.fetchUrl   = quickUrl;
        const meta = btn.querySelector('.feat-cv__variant-price');
        chooseBtn.dataset.collections =
          meta?.dataset?.collections || btn.dataset?.collections || '';
      }

      renderRUKSnippets();

      if (direct) {
        if (atcBtn)    atcBtn.classList.remove('hidden');
        if (chooseBtn) chooseBtn.classList.add('hidden');
      } else {
        if (atcBtn)    atcBtn.classList.add('hidden');
        if (chooseBtn) chooseBtn.classList.remove('hidden');
      }
    }

    buttons.forEach(b => b.addEventListener('click', () => activate(b)));
    const def = root.querySelector('[data-default="true"]') || buttons[0];
    if (def) activate(def);
  }

  function initAll() {
    const desktops = document.querySelectorAll('.feat-cv__desktop .feat-cv__desktop-grid');
    const mobiles  = document.querySelectorAll('.feat-cv__mobile .feat-cv__mobile-inner');
    desktops.forEach(el => initFeatCV(el, false));
    mobiles.forEach(el => initFeatCV(el, true));
    renderRUKSnippets();
    log('✅ initAll executed', { desktops: desktops.length, mobiles: mobiles.length });
  }

  document.addEventListener('DOMContentLoaded', () => {
    log('🌐 DOMContentLoaded');
    safeLoadRUK();
    initAll();
  });

  document.addEventListener('shopify:section:load', e => {
    log('♻️ shopify:section:load');
    const d = e.target.querySelector('.feat-cv__desktop .feat-cv__desktop-grid');
    const m = e.target.querySelector('.feat-cv__mobile .feat-cv__mobile-inner');
    if (d) initFeatCV(d, false);
    if (m) initFeatCV(m, true);
    renderRUKSnippets();
  });
})();